import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { CircularProgress, Paper, Typography } from '@material-ui/core';

const LoadingModal = ({ show, message, classes }) => {
    if (!show) {
        return null;
    }

    return (
        <div className={classes.container}>
            <Paper className={classes.modal}>
                <div className={classes.content}>
                    <CircularProgress size={60} className={classes.spinner} />
                    {message && (
                        <Typography variant="subheading" className={classes.message}>
                            {message}
                        </Typography>
                    )}
                </div>
            </Paper>
            <div className={classes.background} />
        </div>
    );
};

LoadingModal.propTypes = {
    show: PropTypes.bool,
    message: PropTypes.string,
    classes: PropTypes.object.isRequired,
};

LoadingModal.defaultProps = {
    show: false,
    message: 'Processing...',
};

const style = ({ palette, spacing }) => ({
    container: {
        width: 0,
        height: 0,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '30px',
    },
    spinner: {
        marginBottom: spacing.unit * 2,
    },
    message: {
        textAlign: 'center',
    },
    background: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: 'rgba(0, 0, 0, 0.5)',
    },
    modal: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        width: '300px',
        transform: 'translate(-50%, -50%)',
        zIndex: 1001,
    },
});

export default injectSheet(style)(LoadingModal); 


// WEBPACK FOOTER //
// ./src/components/modals/LoadingModal.js